import http from "../../utils/http"

/**
 * 获取公告列表
 */
export function noticesList(params) {
    return http({
        url: "/api/notice/page",
        data: params
    })
}
/**
 * 获取公告详情
 */
export function noticeDetail(params) {
    return http({
        url: "/api/notice/info",
        data: params
    })
}
/**
 * 获取交易规则列表
 */
export function traceList(params) {
    return http({
        url: "/api/notice/tradepage",
        data: params
    })
}
/**
 * 获取交易规则详情
 */
export function traceDetail(params) {
    return http({
        url: "/api/notice/tradeinfo",
        data: params
    })
}